/**
 * Brand gradient for chatbot header surfaces, derived from the DaisyUI primary
 * token so it tracks each tenant's theme.
 */
export const CHATBOT_HEADER_GRADIENT =
  'linear-gradient(135deg, var(--color-primary), color-mix(in oklch, var(--color-primary), black 14%))';
